import React from 'react';
import { motion } from 'framer-motion';
export const Callout: React.FC = () => {
  return <section className="py-24 px-6 bg-charcoal text-cream text-center relative overflow-hidden" data-id="element-9">
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#B8963E 2px, transparent 2px)',
      backgroundSize: '40px 40px'
    }} data-id="element-10"></div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.8
    }} className="max-w-4xl mx-auto relative z-10" data-id="element-11">
        <div className="w-16 h-px bg-gold mx-auto mb-10" data-id="element-12"></div>
        <h2 className="text-3xl md:text-5xl font-serif leading-tight text-white" data-id="element-13">
          Tu independencia no es el problema.
          <br className="hidden md:block mt-2" data-id="element-14" />
          <span className="text-gold" data-id="element-15">
            Tu independencia es tu mejor filtro.
          </span>
        </h2>
        <div className="w-16 h-px bg-gold mx-auto mt-10" data-id="element-16"></div>
      </motion.div>
    </section>;
};